export default __webpack_public_path__ + "static/media/SonaMariyamSunny.482a0a8a.png";